(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', (event) => {
  if (!window.matchMedia('(min-width: 990px)').matches) return;
  const opened = event.target;
  if (!(opened instanceof HTMLDetailsElement) || !opened.open || !opened.querySelector(':scope > .desktop-guide-menu')) return;
  const navigation = opened.closest('.header__inline-menu');
  if (!navigation) return;
  const panel = opened.querySelector(':scope > .desktop-guide-menu');
  panel.style.translate = '0px 0px';
  const bounds = panel.getBoundingClientRect();
  const shift = Math.max(16 - bounds.left, Math.min(0, window.innerWidth - 16 - bounds.right));
  panel.style.translate = `${shift}px 0px`;
  navigation.querySelectorAll('details[open]').forEach((other) => {
    if (other !== opened && other.querySelector(':scope > .desktop-guide-menu')) {
      other.open = false;
      other.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    }
  });
}, true);
  } catch(e) { console.error(e); }
})();

})();
